<template>
  <v-row class="mt--20">
    <v-col cols="12">
      <div class="brand-section">
        <ul class="brand-style-2 brand-grid">
          <li v-for="(brand, i) in brandImages" :key="i" class="brand-item" :title="brand.label">
            <a v-if="brand.url" :href="brand.url" class="brand-link" target="_blank" rel="noopener" :aria-label="brand.label">
              <img :src="brand.src" :alt="brand.label + ' - Cliente Codetime'" class="brand-logo" />
            </a>
            <img v-else :src="brand.src" :alt="brand.label + ' - Cliente Codetime'" class="brand-logo" />
          </li>
        </ul>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    data() {
      return {
        brandImages: [
          { src: "/icones/atos.webp", url: "#", label: "Atos Consultoria" },
          { src: "/icones/llp.webp", url: "#", label: "LLP Contabilidade" },
          { src: "/icones/g1motors.webp", url: "#", label: "G1 Motors" },
          { src: "/icones/g6cred.webp", url: "https://g6cred.com.br/", label: "G6Cred" },
          { src: "/icones/lebasi.webp", url: "/projeto/lebasi", label: "Lebasi" },
          { src: "/icones/portalcegonheiros.webp", url: "#", label: "Portal Cegonheiro" },
          { src: "/icones/gestor.webp", url: "#", label: "Gestor Top" },
          { src: "/icones/avelar.webp", url: "#", label: "Grupo Avelar" },
          { src: "/icones/health.webp", url: "#", label: "MHealth" },
          { src: "/icones/mgroup.webp", url: "#", label: "+M Group" },
          { src: "/icones/acesso.webp", url: "#", label: "Acesso Transparência" },
          { src: "/icones/jobclin.webp", url: "#", label: "JobClin" },
        ],
      };
    },
  };
</script>

<style scoped>
.brand-section {
  position: relative;
  padding: 10px 8px 0;
  border-radius: 16px;
  /* glow sutil no topo e à direita */
  background:
    radial-gradient(1200px 300px at 50% -50%, rgba(0, 172, 255, 0.07), transparent 65%),
    radial-gradient(900px 260px at 90% -40%, rgba(249, 0, 77, 0.05), transparent 65%);
}
.brand-section::before {
  /* removido o quadriculado: apenas um overlay sutil (desativado) */
  content: none;
}
.brand-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 28px 36px;
  padding: 0;
  list-style: none;
}
.brand-item {
  width: 200px; /* largura padronizada do box */
  height: 92px; /* altura padronizada do box */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform .25s ease, opacity .25s ease;
  animation: fadeUp .6s ease both;
}
.brand-logo {
  max-height: 48px; /* altura máxima do logo */
  max-width: 140px; /* largura máxima do logo */
  width: 100%;
  height: auto;
  object-fit: contain; /* evita distorção */
  /* volta ao p&B elegante por padrão */
  filter: grayscale(100%) brightness(0.95);
  opacity: 0.9;
  transition: filter .25s ease, opacity .25s ease, transform .25s ease;
}
.brand-link, .brand-link:visited { text-decoration: none; }
.brand-item:hover { transform: translateY(-2px); }
.brand-item:hover .brand-logo {
  filter: grayscale(0%) brightness(1) contrast(1);
  opacity: 1;
  transform: scale(1.03);
}
@media (max-width: 600px) {
  .brand-item { width: 150px; height: 76px; }
  .brand-logo { max-height: 42px; max-width: 120px; }
}

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
/* atraso progressivo para sensação de vida */
.brand-item:nth-child(1) { animation-delay: .02s }
.brand-item:nth-child(2) { animation-delay: .04s }
.brand-item:nth-child(3) { animation-delay: .06s }
.brand-item:nth-child(4) { animation-delay: .08s }
.brand-item:nth-child(5) { animation-delay: .10s }
.brand-item:nth-child(6) { animation-delay: .12s }
.brand-item:nth-child(7) { animation-delay: .14s }
.brand-item:nth-child(8) { animation-delay: .16s }
.brand-item:nth-child(9) { animation-delay: .18s }
.brand-item:nth-child(10) { animation-delay: .20s }
</style>
